module.exports = __webpack_public_path__ + "img/reason3.a4a51902.png";